import { AuthLayout, RedirectToDefault } from "./components/Layouts/AuthLayout";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { useEffect, useState } from "react";

import ChatLayout from "./components/Layouts/ChatLayout";
import Login from "@/components/Login/Login";
import NotFound from "./components/NotFound/NotFound";
import { PulseLoader } from 'react-spinners';
import TwoFactorAuth from "@/components/Login/TwoFactorAuth";
import { checkAuthStatus } from "@/features/auth/authSlice";
import { useAppDispatch } from "@/hooks/redux";

function App() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const updateAuthStatus = async () => {
      await dispatch(checkAuthStatus());
      setLoading(false);
    };

    updateAuthStatus();
  }, [dispatch]);

  useEffect(function preventDefaultFileDropBehavior() {
    const preventDefault = (e: DragEvent) => {
      e.preventDefault();
    };

    window.addEventListener("dragover", preventDefault);
    window.addEventListener("drop", preventDefault);

    return () => {
      window.removeEventListener("dragover", preventDefault);
      window.removeEventListener("drop", preventDefault);
    };
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center w-screen h-dvh">
        <PulseLoader color="gray"/>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<RedirectToDefault />} />
        <Route path="/login" element={<Login />} />
        <Route path="/2fa" element={<TwoFactorAuth />} />
        <Route element={<AuthLayout />}>
          <Route path="/chat" element={<ChatLayout />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
